// @flow
/* eslint pinterest/no-translation-outside-of-function: 0 */
import i18n from 'app/common/lib/i18n';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';

/**
 * Transform an array of items (strings) interpolated into a comma-delimited list of up to 6 items.
 * If there are more than 6 items, 5 will be listed, and the remainder will be indicated.
 * No oxford comma.
 *
 * Port of list_items_and from webapp/templates/macros/concatList.nunjucks
 */
export default function listItemsAnd(listOfItems: Array<string>) {
  const interpolationContext = {
    first: listOfItems[0],
    second: listOfItems[1],
    third: listOfItems[2],
    fourth: listOfItems[3],
    fifth: listOfItems[4],
    sixth: listOfItems[5],
    remaining: listOfItems.length - 5,
  };

  switch (listOfItems.length) {
    case 0:
      return undefined;

    case 1:
      return interpolateNamedTemplate(i18n._('{{ first }}'), interpolationContext);

    case 2:
      return interpolateNamedTemplate(i18n._('{{ first }} and {{ second }}'), interpolationContext);

    case 3:
      return interpolateNamedTemplate(
        i18n._('{{ first }}, {{ second }} and {{ third }}'),
        interpolationContext,
      );

    case 4:
      return interpolateNamedTemplate(
        i18n._('{{ first }}, {{ second }}, {{ third }} and {{ fourth }}'),
        interpolationContext,
      );

    case 5:
      return interpolateNamedTemplate(
        i18n._('{{ first }}, {{ second }}, {{ third }}, {{ fourth }} and {{ fifth }}'),
        interpolationContext,
      );

    case 6:
      return interpolateNamedTemplate(
        i18n._('{{ first }}, {{ second }}, {{ third }}, {{ fourth }}, {{ fifth }} and {{ sixth }}'),
        interpolationContext,
      );

    default:
      // More than 6 items in the list
      return interpolateNamedTemplate(
        i18n._(
          '{{ first }}, {{ second }}, {{ third }}, {{ fourth }}, {{ fifth }} and {{ remaining }} others',
        ),
        interpolationContext,
      );
  }
}
